export const exampleText = {
  default: 'Click me!',
  none: '',
  short_ipsum: 'Lorum',
  short_sentence: 'Did you think you have mastery over fire? Incredible!',
  long_ipsum: `Lorem ip sum dolor sit amet, consectetur adipiscing elit,
    ed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Scelerisque eleifend donec pretium vulputate sapien nec sagittis.
    Ultricies tristique nulla aliquet enim tortor at auctor urna nunc.
    Vitae turpis massa sed elementum tempus egestas.
    Nunc consequat interdum varius sit amet`,
  longest_ipsum: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua. Ac tortor dignissim
    convallis aenean et. Facilisis volutpat est velit egestas dui id. In
    nulla posuere sollicitudin aliquam ultrices. Lorem mollis aliquam ut
    porttitor. Convallis aenean et tortor at risus viverra adipiscing at.
    Euismod nisi porta lorem mollis aliquam ut porttitor. Hac habitasse
    platea dictumst vestibulum rhoncus est pellentesque elit ullamcorper.
    Viverra tellus in hac habitasse platea dictumst. Scelerisque viverra lawn
    gnome in aliquam sem fringilla ut morbi tincidunt. Ullamcorper morbi tincidunt
    ornare massa eget. Gravida cum sociis natoque penatibus. Leo vel fringilla est
    ullamcorper eget nulla. Vitae proin sagittis nisl rhoncus mattis rhoncus urna.
    Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Id aliquet
    lectus proin nibh troll condimentum id venenatis.`,
  long_ipsum_one_line: `Lorem ip sum dolor sit amet, consectetur adipiscing elit, ed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Ultricies tristique nulla aliquet enim tortor at auctor urna nunc. Vitae turpis massa sed elementum tempus egestas. Nunc consequat interdum varius sit amet`,
  formatted_content: `
    <p><strong>Bold text</strong> and <em>italic text</em></p>
    <ul>
      <li>List item 1</li>
      <li>List item 2</li>
    </ul>
    <p style="text-align: center;">Centered text</p>
  `,
}

export function Ipsum(
  lengthOrOptions:
    | number
    | {
        length: number
        lettercase?: 'sentence' | 'title'
        trailingPeriod?: boolean
      }
) {
  if (typeof lengthOrOptions === 'number') {
    return recursiveGrow(lengthOrOptions)
  }
  const { length, lettercase, trailingPeriod } = lengthOrOptions
  let longString = recursiveGrow(length)
  const lastChar = longString[longString.length - 1]
  if (!trailingPeriod && ['.', ','].includes(lastChar)) {
    longString = longString.slice(0, -1)
  }
  if (lettercase === 'title') {
    longString = longString.replace(/\b\w/g, (s) => s.toUpperCase())
  }
  return longString
}

/**
 * Creates a sentence case sentence.
 * @returns string
 */
const recursiveGrow = (length = 1, out = exampleText.longest_ipsum): string => {
  if (!length) {
    return ''
  }
  if (out.length < length) {
    return recursiveGrow(length, out + exampleText.longest_ipsum)
  }
  if (out.length >= length) {
    return out.slice(0, length - 1) + '.'
  }
  return 'Lorem ipsum grow failed.'
}
